let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9d6gK")).then(() => parcelRequire('8G8gO'));